import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import SpreadPartial from '../spread-partial';
import { ordinal } from '../../../util.js';

class Component extends BaseComponent {
    componentWillMount() {
        const houses = this.props.positions.map(position => (position.title));

        let keep = [0,1,2,3,4,5,6,7,8,9,10,11];

        if (this.props.type == 'balance') {
            keep = [1,4,7,10];
        } else if (this.props.type == 'beginnings') {
            keep = [0,3,6,9];
        } else if (this.props.type == 'changes') {
            keep = [2,5,8,11];
        }

        const activeHouses = keep.map(k => (houses[k]));

        this.setState({
            house: null,
            houses: activeHouses,
        });
    }

    render({ type, positions }) {
        return (
            <mandala-spread type={type} house={this.state.house}>
                {this.renderHouseSelector()}
                {this.renderImg()}
                <SpreadPartial
                  positions={positions.map((p, i) => ({...p, card_index: i}))}
                  houses={this.state.houses}
                />
            </mandala-spread>
        );
    }

    renderHouseSelector = () => {
        if (this.props.positions.length == 1) {
            return (
                <select onChange={this.changeHouse}>
                    <option disabled selected>Choose a House</option>
                    {this.state.houses.map((house, i) => (
                        <option value={house} selected={this.state.house == house}>
                            {`${ordinal(i + 1)} House - ${house}`}
                        </option>
                    ))}
                </select>
            );
        }

        return null;
    }

    changeHouse = (e) => {
        const house = e.target.value;

        this.setState({ house: house });
    }

    renderImg = () => {
        if (this.props.cards.length < 12) {
            const base_url = 'https://gfx.tarot.com/images/site/tarot/mandala-tarot-redux/';
            const image_filename = `${this.props.cards.length + 1}.svg`;

            return (
                <img src={base_url + image_filename} class='position-img' />
            );
        }

        return null;
    }

}

const mapStateToProps = (state) => ({
    positions: state['tarot-reading'].positions,
    cards: state['tarot-reading'] && state['tarot-reading'].cards,
});

export default connect(mapStateToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/tarot-readings/spreads/mandala.js